export const environment = {
	production: true,
	environmentName: 'develop',
	apiUrl: 'https://everpaths.quartdepoblet.es',

	urlCMS: 'https://everpaths.quartdepoblet.es/filerepo/api',

	CMS_user_1: 'everpaths.',
	CMS_user_2: 'everpaths:',
	CMS_sub_token: '457b174c-6441-4f09-be25-6bb1e3b33919',
	CMS_token: 'everpaths:457b174c-6441-4f09-be25-6bb1e3b33919',
	urlBaseFotos: 'everpaths:/everpaths.',
	
	CMS_3d_model_user_1: 'everpaths.',
	CMS_3d_model_user_2: 'everpaths:',
	CMS_3d_model_sub_token: '457b174c-6441-4f09-be25-6bb1e3b33919',
	CMS_3d_model_token: 'everpaths:457b174c-6441-4f09-be25-6bb1e3b33919',
	urlBaseModelo: 'everpaths:/everpaths.',


	urlServicioBreeze: 'https://everpaths.quartdepoblet.es/breeze/Ubimaps',
	ubimapsAPI: 'https://everpaths.quartdepoblet.es/api/',
	ubimapsDiagnostico: 'https://everpaths.quartdepoblet.es/diagnostico/',
	ubimapsStats: 'https://everpaths.quartdepoblet.es/stats/',

	//Personalizaciones parte fija Espacios Cultura
    logo: 'assets/layout/images/ITSN.png',
    tituloLogo: 'Login.navegacioninteriores',
    title: 'Quart de Poblet',
    icon: 'favicon.ico',
    colorTopBar: '#3A4651',
    logoTopBar: 'assets/itsoft/images/ITSNavigation-liso.png',

	urlPublicacionFija: 'http://localhost:4200'
};



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/environments/environment.ts